module.exports = __webpack_public_path__ + "static/media/shapes.6d8b8801.png";